﻿import React from 'react';
import ColumnItems from './ColumnItems';
import PropTypes from 'prop-types';


class TabPanel extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {

        let className = ''

        if(this.props.className !== undefined){
            className = this.props.className
        }
        let columnClasses = "";
        switch(this.props.columns.length) {
            case 2:
                columnClasses = "column small-12 medium-6";
              break;
            case 3:
                columnClasses = "column small-12 medium-6 large-4";
              break;
            case 4:
                columnClasses = "column small-12 medium-6 large-4";
                break;
            default:
                columnClasses = "column small-12";
        }

        return (
            <div role="tabpanel" tabIndex="0" className={className}>
                <div className="row">
                    {
                        this.props.columns.map((column, idx) => {
                            return (
                                <div key={idx} className={columnClasses}>
                                    <ColumnItems items={column.ColumnItems} isBio={this.props.isBio} />
                                </div>
                            )
                        })
                    }

                </div>
                {this.props.disclaimer && 
                    <div className="row">
                        <div className="column small-12 disclaimer-content" dangerouslySetInnerHTML={{ __html: this.props.disclaimer }}></div>
                    </div>                
                }

                
            </div>
        )
    }
}


TabPanel.propTypes = {
    className: PropTypes.string.isRequired,
    columns: PropTypes.array.isRequired
};

TabPanel.defaultProps = {
    className: '', 
    columns: []
};


export default TabPanel;